import React from 'react';
import { useField } from 'formik';
import { FormFieldWrapper } from './FormFieldWrapper';
import { CustomForm } from '.generated/Feature.Irwinmitchell.model';

interface RecaptchaFieldProps {
  field: CustomForm.FormField_Item;
  hasError?: boolean;
  isTouched?: boolean;
  reCAPTCHASiteKey?: string;
}

export const RecaptchaField: React.FC<RecaptchaFieldProps> = ({
  field,
  hasError = false,
  reCAPTCHASiteKey = '',
}) => {
  const fieldConfig = field.fields;
  const fieldName = fieldConfig?.fieldName?.value || fieldConfig?.fieldId?.value;
  const label = fieldConfig?.label?.value || 'reCAPTCHA Verification';
  const helpText = fieldConfig?.helpText?.value;
  const disabled = fieldConfig?.disabled?.value;
  const required = fieldConfig?.required?.value;

  const [, meta] = useField(fieldName || 'recaptcha');

  // Get site key - checking if it's provided
  const siteKey = reCAPTCHASiteKey || process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || '';

  // Note: Token generation is now handled in DynamicForm.tsx before form submission
  // This field just holds the token value

  if (!fieldName) return null;

  if (!siteKey) {
    console.warn('reCAPTCHA site key is required but not provided');
    return (
      <FormFieldWrapper
        key={fieldName}
        fieldName={fieldName}
        label={label}
        helpText="reCAPTCHA is not configured properly"
        isDisabled={true}
        hasError={true}
        isRequired={required}
      >
        <div className="text-color-text-text-critical text-typography-font-size-body-small">
          reCAPTCHA v3 configuration error
        </div>
      </FormFieldWrapper>
    );
  }

  return (
    <FormFieldWrapper
      key={fieldName}
      fieldName={fieldName}
      label={label}
      helpText={helpText}
      isDisabled={disabled}
      hasError={hasError}
      isRequired={required}
      hideLabel={true}
    >
      <div className="flex items-center gap-spacing-spacing-8">
        <input type="hidden" name={fieldName} value={meta.value || ''} data-recaptcha-field />
        {/* <div className="text-typography-font-size-body-small text-color-text-text-secondary flex items-center gap-spacing-spacing-4">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
          </svg>
          <span>Protected by reCAPTCHA v3</span>
        </div> */}
      </div>
    </FormFieldWrapper>
  );
};

export default RecaptchaField;
